import React, { useState } from 'react';
import { TEAM } from '../../data/siteData';
import SectionHeader from '../common/SectionHeader';

const AVATAR_COLORS = [
  { bg: 'rgba(201,168,76,0.15)', color: 'var(--gold)' },
  { bg: 'rgba(29,158,117,0.12)', color: '#1D9E75' },
  { bg: 'rgba(55,138,221,0.12)', color: '#378ADD' },
];

function TeamCard({ member, index }) {
  const [hovered, setHovered] = useState(false);
  const colors = AVATAR_COLORS[index % AVATAR_COLORS.length];

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '32px',
        background: hovered ? 'rgba(201,168,76,0.05)' : 'rgba(255,255,255,0.02)',
        border: '1px solid',
        borderColor: hovered ? 'rgba(201,168,76,0.3)' : 'rgba(201,168,76,0.1)',
        borderRadius: 'var(--radius-md)',
        transition: 'all 0.25s ease',
        display: 'flex', flexDirection: 'column', gap: '16px',
        boxShadow: hovered ? '0 8px 32px rgba(201,168,76,0.12)' : 'none',
      }}
    >
      <div style={{
        width: '60px', height: '60px', borderRadius: '50%',
        background: colors.bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'var(--font-serif)', fontSize: '20px', fontWeight: 600,
        color: colors.color,
        border: `1px solid ${colors.color}30`,
      }}>
        {member.initials}
      </div>

      <div>
        <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '20px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '4px' }}>
          {member.name}
        </h3>
        <span style={{ fontSize: '12px', color: 'var(--gold)', letterSpacing: '0.07em', textTransform: 'uppercase' }}>
          {member.role}
        </span>
      </div>

      <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 1.75, fontWeight: 300 }}>
        {member.bio}
      </p>
    </div>
  );
}

export default function TeamSection() {
  return (
    <section id="team" className="section" style={{ background: 'var(--ink)' }}>
      <div className="container">
        <SectionHeader
          tag="Our People"
          title='Meet the <em style="color:var(--gold);font-style:normal">Team</em>'
          center
        />
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
        }}>
          {TEAM.map((member, i) => (
            <TeamCard key={member.id} member={member} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
